import { Box, Typography, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import TradersRoomBox from "./TradersRoomBox";
import DashboardMultiOI from "./MultiOIBox";
import FeaturesBox from "./FeaturesBox";
import OptionChainBox from "./OptionChianBox";
import Footer  from "components/Dashboard/footer";
import GridLines from "components/Common/GridLine";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./dashboard.css";
// import { useDispatch, useSelector } from "react-redux";

const Dashboard = () => {
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setContentHeight(document.body.scrollHeight);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("page", "home");
  }, []);

  function WelcomeMessage() {
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down("sm"));
    // const dispatch = useDispatch();

    return (
      
      <Box textAlign="center" marginBottom={"5rem"}>
        <Typography
          variant="h5"
          mt={1}
          style={{
            fontWeight: "600",
            color: "#000",
            marginTop: !smDown ? "-6rem" : "6rem",
          }}
        >
          Streamline your trading analysis with ChartingHQ
        </Typography>
        <Typography
          variant="h5"
          mt={1}
          style={{ fontWeight: "200", marginTop: "10px", color: "#000" }}
        >
          Access option chains, combined charts, multiOI, pcr meter, traders
          room and more
          {/* <p class="cursor typewriter-animation"> Welcome back, {profileData?.Name}</p> */}
        </Typography>
      </Box>
    );
  }

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box minHeight="100vh" >
    
      <GridLines
          cellWidth={100}
          strokeWidth={1}
          cellWidth2={1}
          height={contentHeight}
          width={window.innerWidth - 10}
        />

        <Box
          sx={{
            position: "relative", // Relative position to contain absolutely positioned elements
            padding: "2rem",
          }}
        >
          <Grid
            container
            spacing={4}
            display={"flex"}
            justifyContent={"center"}
            // marginTop={"10rem"}
          >
            <Grid
              item
              xs={12}
              lg={12}
              sm={12}
              height={smDown ? "100%" : "100vh"}
              justifyContent={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <WelcomeMessage />

              <FeaturesBox />
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              lg={12}
              margin={!smDown ? "0rem 2rem 0rem 2rem" : "0rem 0rem 18rem 0rem"}
              height={"100vh"}
            >
              <OptionChainBox />
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              lg={12}
              margin={!smDown ? "0rem 2rem 0rem 2rem" : "0rem 0rem 18rem 0rem"}
              height={"100vh"}
            >
              <DashboardMultiOI />
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              lg={12}
              margin={!smDown ? "0rem 2rem 0rem 2rem" : "0rem 0rem 18rem 0rem"}
              height={"100vh"}
            >
              <TradersRoomBox />
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box>
      <Footer />
      </Box>
      
    </>
  );
};

export default Dashboard;
